import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=1a9c846f&scoped=true&lang=pug"
import script from "./the-header.js?vue&type=script&lang=js&external"
export * from "./the-header.js?vue&type=script&lang=js&external"
import style0 from "./the-header.vue?vue&type=style&index=0&id=1a9c846f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c846f",
  null
  
)

export default component.exports